import { buildChartOptions } from '@configurations/campaignAnalytics/footTrafficOverlapChart';
import { Stack } from '@mui/material';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { ChartCard } from '../ChartCard';
import { EditableChartProps } from './chartProps';

type FootTrafficOverlapProps = EditableChartProps;

const FootTrafficOverlap = (props: FootTrafficOverlapProps) => {
  const { report, ...chartCardProps } = props;

  if (!report) return null;

  return (
    <ChartCard
      title="Foot Traffic Overlap"
      description={`${props.campaignName} (${props.campaignId})`}
      report={report.footTrafficOverlap}
      {...chartCardProps}
    >
      <Stack alignItems="center">
        <HighchartsReact
          highcharts={Highcharts}
          options={buildChartOptions(
            report.footTrafficOverlap.data.toSorted((a, b) => b.value - a.value)
          )}
        />
      </Stack>
    </ChartCard>
  );
};

export default FootTrafficOverlap;
